import { BudgetBys, BudgetPhases } from 'business/constants';
import {
    getFieldForPhase,
    getPhasedFieldsUntilPhase,
    amountMetricToPhase,
} from 'routes/BudgetModule/shared/phases/helpers';
import {
    BudgetProposalT,
    DraftOperationAssociationT,
    ResourceBudgetProposalAssociationT,
    StatusesSettingsT,
} from 'routes/BudgetModule/config/types';
import { snakify } from 'helpers/syntaxHelper';
import { RQAPICallWithData } from 'store/APIClient';
import { useQuery } from '@tanstack/react-query';

export const ORDERED_LIST_METRIC = getPhasedFieldsUntilPhase(
    BudgetPhases.SUPPLEMENTARY_BUDGET,
    'amount',
);

// TODO: Move to phase helpers when amountMetrics will be moved there as well
export const filterRejectedInscription = (
    metric: string,
    inscriptions: ResponseDataT[],
    statusesSettings: StatusesSettingsT,
): ResponseDataT[] => {
    const phase = amountMetricToPhase[metric];

    return inscriptions.filter(
        (inscription) =>
            !getFieldForPhase(phase, 'isInscriptionRejected')(
                // @ts-expect-error [TS migration] inscription not InscriptionT now
                inscription,
                statusesSettings,
            ),
    );
};

export const useGetResourcesByBudgetProposal = ({
    budgetBy,
}: {
    budgetBy: BudgetBys;
}) =>
    useQuery({
        queryKey: ['ResourcesByBudgetProposal', budgetBy],

        queryFn: async () => {
            const response = await RQAPICallWithData<
                ResourceBudgetProposalAssociationT[]
            >({
                endpoint: `budget_proposals/edition/resource_association/${snakify(budgetBy)}`,
                method: 'GET',
            });
            return response.content.data;
        },
    });

export const mergeAssociationData = ({
    budgetProposals,
    associations,
}: {
    budgetProposals: BudgetProposalT[] | null | undefined;
    associations: DraftOperationAssociationT[];
}): ResourceBudgetProposalAssociationT[] => {
    if (!budgetProposals || !associations) {
        return [];
    }

    const mergedAssociations: ResourceBudgetProposalAssociationT[] = [];

    associations.forEach((association) => {
        const budgetProposal = budgetProposals.find(
            (bp) => bp.id === association.budgetProposalId,
        );
        if (!budgetProposal) return;
        const resource = association.orgChartFinanceName
            ? {
                  resourceSoftwareId:
                      association.orgChartFinanceSoftwareId ?? '',
                  resourceName: association.orgChartFinanceName ?? '',
              }
            : {
                  resourceSoftwareId: association.gestionnaireSoftwareId ?? '',
                  resourceName: association.gestionnaireName ?? '',
              };

        mergedAssociations.push({ budgetProposal, resource });
    });

    return mergedAssociations;
};
